var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoBb(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Camada_2",
    "data-name": "Camada 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 775.82 775.57",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #1e447f;\n        fill-rule: evenodd;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Camada_1-2",
    "data-name": "Camada 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m301.61,574.57l-86.17-57.53,388.03-258.51-215.68-143.71-107.72,71.98,86.42,57.04-194.14,129.5L0,258.28,387.79,0l388.03,258.27-474.2,316.3h0Zm-129.26,86.18l-86.17-57.53L0,660.75v114.82l172.35-114.82h0ZM689.64,172.35l-86.17-57.53L775.82,0v114.81l-86.18,57.53h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m495.76,588.77l-86.42-57.78,193.88-129.25,172.6,115.3-388.03,258.53L.01,517.04,473.96,200.99l86.18,57.53-387.78,258.51,215.44,143.71,107.97-71.97h-.01Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoBb);
export default __webpack_public_path__ + "static/media/logo-bb.1390b618a54f94257d6b8c83012123e1.svg";
export { ForwardRef as ReactComponent };